import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M15.3537 3.64645C15.549 3.84171 15.549 4.15829 15.3537 4.35355L8.76795 10.9394C8.18217 11.5251 8.18217 12.4749 8.76795 13.0607L15.3537 19.6464C15.549 19.8417 15.549 20.1583 15.3537 20.3536C15.1585 20.5488 14.8419 20.5488 14.6466 20.3536L8.06085 13.7678C7.08454 12.7915 7.08453 11.2086 8.06084 10.2323L14.6466 3.64645C14.8419 3.45118 15.1585 3.45118 15.3537 3.64645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeft;
